import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { Outlet, useLocation } from 'react-router-dom';
import ScrollRestoration from './ScrollRestoration';

const Layout = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const employmentStatus = localStorage.getItem('employmentStatus');
  
  // Hide sidebar on waiting page when employmentStatus is "WAITING FOR APPROVAL"
  const isWaitingPage = pathname === '/waiting';
  const isWaitingForApproval = employmentStatus && 
    (employmentStatus === 'WAITING FOR APPROVAL' || 
     employmentStatus.toLowerCase() === 'waiting for approval' || 
     employmentStatus.toLowerCase() === 'waiting_for_approval');
  const shouldHideSidebar = isWaitingPage && isWaitingForApproval;

  return (
    <div className="wrapper">
      <Header />
      {!shouldHideSidebar && <Sidebar />}
      <div className={`content-wrapper ${shouldHideSidebar ? 'no-sidebar' : ''}`}>
        <ScrollRestoration />
        <Outlet /> 
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
